import React from 'react';
import { useRegions } from 'modules/geo';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';
import { Country } from '@trnsact/trnsact-shared-types';

import { DealSheetRulesFilters } from './index';

export const State = () => {
  const { control } = useFormContext<DealSheetRulesFilters>();

  const { regions, loading } = useRegions(Country.Us);

  return (
    <AutocompleteField
      multiple
      size="small"
      name="STATE"
      control={control}
      options={regions}
      loading={loading}
      disableCloseOnSelect
      textFieldProps={{ variant: 'outlined', label: 'State' }}
    />
  );
};
